import React from "react";
import PropTypes from "prop-types";

import ScanConfirmationDialog, {
    SCAN_DIALOG_DATA_PROPTYPES,
} from "./ScanConfirmationDialog";
import { useDialogState } from "./hooks/useDialogState";
import { useDialogManager } from "./hooks/useDialogManager";
import { useDialogActions } from "./hooks/useDialogActions";

const ScanConfirmationDialogContainer = (props) => {
    const [state, setState] = useDialogState(props.dialogData);
    const show = useDialogManager(state, setState);
    const { handleChoiceSubmitted, handleClose } = useDialogActions(
        state,
        setState,
        show,
    );

    return (
        <ScanConfirmationDialog
            {...state.dialogData}
            status={state.status}
            onClose={handleClose}
            onChoiceSubmitted={handleChoiceSubmitted}
        />
    );
};

ScanConfirmationDialogContainer.propTypes = {
    dialogData: PropTypes.shape({
        ...SCAN_DIALOG_DATA_PROPTYPES,
        allowClose: PropTypes.bool,
        reloadPageAfterScan: PropTypes.bool,
    }),
    userChoiceUrl: PropTypes.string,
};

export default ScanConfirmationDialogContainer;
